import { getUniqueId } from '@/utils/misc'
import { MAP_STATUS_BY_VALUE } from '@/apis/data/statistik/status'
import { LOCATION_LEVEL } from '@/apis/data/statistik/wilayah'

import { sendTrackerGA } from '../gaTracker'
import { sendTrackerSatuEvent } from '../satuTracker'

export const trackClickOpenWilayahDialog = () => {
  const trackerId = getUniqueId()
  sendTrackerGA({
    id: trackerId,
    eventName: 'dataset',
    eventAction: 'FILTER_WILAYAH_OPENED',
    eventParams: {},
  })
}

export const trackClickSelectWilayah = (label: string) => {
  const trackerId = getUniqueId()
  sendTrackerGA({
    id: trackerId,
    eventName: 'dataset',
    eventAction: 'FILTER_WILAYAH_SELECTED',
    eventParams: {
      eventLabel: label,
    },
  })
}

export interface DatasetTrackerArgs {
  tableNum: string
  districtId: string
  districtLevel: number
  yearPeriod: number
  educationLevelName: string
  educationStatus?: string
}

export const trackViewDataset = ({
  tableNum,
  districtId,
  districtLevel,
  yearPeriod,
  educationLevelName,
  educationStatus,
}: DatasetTrackerArgs) => {
  const trackerId = getUniqueId()
  const status = educationStatus
    ? `${MAP_STATUS_BY_VALUE[educationStatus || '']?.toLowerCase() || ''}`
    : ''
  const withStatus = status ? ` - ${status}` : ' - semua'
  const eventLabel = `${tableNum} - ${districtId} - ${yearPeriod} - ${educationLevelName}${withStatus}`
  sendTrackerGA({
    id: trackerId,
    eventName: 'dataset',
    eventAction: 'TABLE_VIEWED',
    eventParams: {
      eventLabel: eventLabel,
    },
  })

  const locationLevel = LOCATION_LEVEL[districtLevel] || 'Nasional'
  sendTrackerSatuEvent({
    id: trackerId,
    pageTitle: 'Dataset',
    activityType: 'TABLE_VIEWED',
    eventParams: {
      reference_id: tableNum,
      location_id: districtId,
      location_level: locationLevel,
      year: yearPeriod,
      jenjang: educationLevelName,
      status,
    },
  })
}

export const trackViewDatasetEmptyState = ({
  tableNum,
  districtId,
  yearPeriod,
  educationLevelName,
  educationStatus,
}: DatasetTrackerArgs) => {
  const trackerId = getUniqueId()
  const status = educationStatus
    ? `${MAP_STATUS_BY_VALUE[educationStatus || '']?.toLowerCase() || ''}`
    : ''
  const withStatus = status ? ` - ${status}` : ' - semua'
  const eventLabel = `${tableNum} - ${districtId} - ${yearPeriod} - ${educationLevelName}${withStatus}`

  sendTrackerGA({
    id: trackerId,
    eventName: 'dataset',
    eventAction: 'EMPTY_TABLE_VIEWED',
    eventParams: {
      eventLabel: eventLabel,
    },
  })
}

export const trackClickDownloadDataset = (
  {
    tableNum,
    districtId,
    districtLevel,
    yearPeriod,
    educationLevelName,
    educationStatus,
  }: DatasetTrackerArgs,
  fileType: string
) => {
  const trackerId = getUniqueId()
  const status = educationStatus
    ? `${MAP_STATUS_BY_VALUE[educationStatus || '']?.toLowerCase() || ''}`
    : ''
  const withStatus = status ? ` - ${status}` : ' - semua'
  const eventLabel = `${tableNum} - ${districtId} - ${yearPeriod} - ${educationLevelName}${withStatus} - ${fileType}`

  sendTrackerGA({
    id: trackerId,
    eventName: 'dataset',
    eventAction: 'DOWNLOAD_BUTTON_CLICKED',
    eventParams: {
      eventLabel: eventLabel,
    },
  })

  const locationLevel = LOCATION_LEVEL[districtLevel] || 'Nasional'
  sendTrackerSatuEvent({
    id: trackerId,
    pageTitle: 'Dataset',
    activityType: 'DOWNLOAD_BUTTON_CLICKED',
    eventParams: {
      tableNum,
      yearPeriod,
      location_id: districtId,
      location_level: locationLevel,
      jenjang: educationLevelName,
      status,
      format: fileType,
    },
  })
}

export const trackClickViewMoreDataset = () => {
  const trackerId = getUniqueId()
  sendTrackerGA({
    id: trackerId,
    eventName: 'dataset',
    eventAction: 'VIEW_MORE_BUTTON_CLICKED',
    eventParams: {},
  })
}

interface DatasetSearchTrackerArgs {
  keyword: string
  districtLevel: number
  districtId: string
  yearPeriod: number
  educationLevelName: string
}

export const trackSearchDataset = ({
  districtId,
  districtLevel,
  yearPeriod,
  educationLevelName,
  keyword,
}: DatasetSearchTrackerArgs) => {
  if (keyword !== '') {
    const trackerId = getUniqueId()
    const eventLabel = `${keyword} - ${districtId} - ${yearPeriod} - ${educationLevelName}`

    sendTrackerGA({
      id: trackerId,
      eventName: 'dataset',
      eventAction: 'SEARCH_BUTTON_CLICKED',
      eventParams: {
        eventLabel: eventLabel,
      },
    })

    const locationLevel = LOCATION_LEVEL[districtLevel] || 'Nasional'
    sendTrackerSatuEvent({
      id: trackerId,
      pageTitle: 'Dataset',
      activityType: 'SEARCH_BUTTON_CLICKED',
      eventParams: {
        keyword,
        location_id: districtId,
        location_level: locationLevel,
        year: yearPeriod,
        jenjang: educationLevelName,
      },
    })
  }
}

export const trackViewDatasetList = ({
  districtId,
  districtLevel,
  yearPeriod,
  educationLevelName,
}: {
  districtId: string
  districtLevel: number
  yearPeriod: number
  educationLevelName: string
}) => {
  const trackerId = getUniqueId()
  const eventLabel = `${districtId} - ${yearPeriod} - ${educationLevelName}`
  sendTrackerGA({
    id: trackerId,
    eventName: 'dataset',
    eventAction: 'PAGE_VIEWED',
    eventParams: {
      eventLabel: eventLabel,
    },
  })

  const locationLevel = LOCATION_LEVEL[districtLevel] || 'Nasional'

  sendTrackerSatuEvent({
    id: trackerId,
    pageTitle: 'Dataset',
    activityType: 'PAGE_VIEWED',
    eventParams: {
      location_id: districtId,
      location_level: locationLevel,
      year: yearPeriod,
      jenjang: educationLevelName,
    },
  })
}
